<template>
    <div>
        <div class="user-info-head">

            <Head />
        </div>

        <div class="user-info">
            <!-- 个人信息 -->
            <div class="user-info-top">
            </div>
            <div class="user-info-photo">
                <span>个人信息</span>
                <div class="user-info-photo-box">
                    <el-upload class="avatar-uploader" action="/api/file/upload" :headers="headers" :show-file-list="false"
                        :on-success="handleAvatarSuccess" accept=".jpg,.png">
                        <img v-if="userInfoData.logo" :src="userInfoData.logo" class="avatar upload-photo-img">
                        <img v-else src="../assets/img/user-photo.png">
                    </el-upload>
                </div>
            </div>
            <div class="detailed-information">
                <el-form :data="userInfoData" label-width="90px">
                    <el-form-item label="公司名">
                        <el-input v-model="userInfoData.company" placeholder="请输入公司名" class="user-input"></el-input>
                    </el-form-item>
                    <el-form-item label="公司英文名">
                        <el-input v-model="userInfoData.company_en" placeholder="请输入公司英文名" class="user-input"></el-input>
                    </el-form-item>
                    <el-form-item label="联系方式">
                        <el-input v-model="userInfoData.contact" placeholder="请输入联系方式" class="user-input"></el-input>
                    </el-form-item>
                    <el-form-item label="地址">
                        <el-input v-model="userInfoData.address" placeholder="请输入地址" class="user-input"></el-input>
                    </el-form-item>
                    <el-form-item label="水印文字">
                        <el-input v-model="userInfoData.watermark" placeholder="请输入水印" class="user-input"></el-input>
                    </el-form-item>
                    <el-form-item label="网址">
                        <el-input v-model="userInfoData.website" placeholder="请输入网址" class="user-input website"></el-input>
                    </el-form-item>
                </el-form>
            </div>
            <div class="user-info-footer-btn">
                <el-button class="user-info-cancel" @click="cancelHandle">返回</el-button>
                <el-button class="user-info-confirm" @click="save">确定</el-button>
            </div>
        </div>
    </div>
</template>
  
<script>
import Vue from 'vue';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);
import Head from '../components/head.vue'
export default {
    name: 'userInfo',
    data() {
        return {
            userInfoData: {
                "company": "",
                "logo": "",
                "logo_id": 0,
                "watermark": "",
                "address": "",
                "contact": "",
                "website": "",
                "company_en": ""
            },
            headers: {},
        }
    },
    components: {
        Head
    },

    methods: {
        handleAvatarSuccess(res, file) {
            if (res.code == 200) {
                this.userInfoData.logo = res.data.url;
                this.userInfoData.logo_id = res.data.file_id;
                this.$message.success('上传完成');
            } else {
                this.$message.error('上传失败：' + res.msg);
            }
        },
        cancelHandle() {
            this.$router.go(-1)
        },
        save() {
            this.$post('/user/edit', {
                company: this.userInfoData.company,
                company_en: this.userInfoData.company_en,
                logo_file: this.userInfoData.logo_id,
                watermark: this.userInfoData.watermark,
                address: this.userInfoData.address,
                contact: this.userInfoData.contact,
                website: this.userInfoData.website,
            }).then(res => {
                this.$message.success('修改完成');
                localStorage.setItem("ai-info", JSON.stringify(res.data))
            })
        }
    },
    created() {
        this.headers = { Authorization: 'Bearer ' + localStorage.getItem('ai-token') };
        this.$get('/user/detail').then(res => {
            this.userInfoData = res.data;
        })
    }
}
</script>
  
<style scoped>
.user-info {
    margin: 40px auto;
    width: 610px;
    height: 700px;
    background: #FFFFFF;
    box-shadow: 4px 6px 61px 1px rgba(225, 225, 225, 0.31);
    border-radius: 0px 0px 10px 10px;
    position: relative;
}

.user-info-top {
    width: 610px;
    height: 178px;
    background-image: url(../assets/img/user-bg.png);
    background-repeat: no-repeat;
    background-size: 100% 100%;
}

.user-info-photo {
    display: flex;
    flex-direction: column;
    align-items: center;
    position: absolute;
    left: 56px;
    top: 70px;
}

.user-info-photo-box {
    width: 90px;
    height: 90px;
    border-radius: 50%;
    border: 1px solid #d4e6ff;
    margin-top: 40px;
    overflow: hidden;
}

.detailed-information {
    box-sizing: border-box;
    padding: 0 50px;
    padding-top: 77px;
    padding-bottom: 10px;
    border-bottom: 1px solid #ebf0f6;
}

.detailed-information>>>.el-form-item__label {
    font-size: 14px;
    color: #666;
}

.detailed-information>>>.user-input input {
    border: 1px solid #dadada;
    border-radius: 3px;
}

.user-info-footer-btn {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
    padding-top: 16px;
    padding-bottom: 24px;
}

.user-info-cancel {
    width: 74px;
    height: 40px;
    background-color: rgba(235, 240, 246, 0);
    border: 1px solid #d9dde5;
    border-radius: 3px;
    font-size: 14px;
    color: #606266;
}

.user-info-confirm {
    width: 98px;
    height: 40px;
    background-color: #006cff;
    border: 3px;
    font-size: 14px;
    color: #fff;
}

.website>>>input {
    color: #006CFF;
}

.upload-photo-img {
    width: 90px;
    height: 90px;
    border-radius: 50%;
}

.user-info-head {
    background-color: #fff;
    box-shadow: 2px 3px 29px 0px rgba(214, 214, 214, 0.17);
    height: 70px;
}

/* 修改 */
.user-info-photo .user-info-photo-box .avatar-uploader {
    width: 100%;
    height: 100%;
}

.user-info-photo .user-info-photo-box .avatar-uploader img {
    width: 100%;
    height: 100%;
}

.user-info-photo .user-info-photo-box .avatar-uploader>>>.el-upload {
    width: 100%;
    height: 100%;
}
</style>